import type { Level } from '../engine/level';
import { isAdmin, isUnlocked, type Progress } from './progress';
import { fitRoot, watchViewport } from './viewport';

export function renderSelect(host: HTMLElement, levels: Level[], progress: Progress, onPick: (l: Level) => void): { destroy(): void } {
  const root = document.createElement('div');
  root.className = 'select';
  const packs = [...new Set(levels.map((l) => l.pack))];
  const last = levels.find((l) => l.id === progress.last) ?? levels[0];
  let pack = last?.pack ?? packs[0] ?? '';
  root.innerHTML = `<div class="inner"><header><h1>tile-path</h1><div class="sub">${Object.keys(progress.levels).length} / ${levels.length}${isAdmin() ? ' · 관리자' : ''}</div></header><div class="tabs packs"></div><div class="grid"></div><div class="hardbox" hidden><h2>어려웠던 판 <span class="dim">공략 영상에서 오래 걸린 판 · 초</span></h2><div class="hardlist"></div></div></div>`;
  const packsEl = root.querySelector('.packs')!, grid = root.querySelector('.grid')!;
  const draw = () => {
    packsEl.replaceChildren(...packs.map((p) => { const b = document.createElement('button'); b.className = 'tab' + (p === pack ? ' on' : ''); b.textContent = p; b.onclick = () => { pack = p; draw(); }; return b; }));
    const list = levels.filter((l) => l.pack === pack).sort((a, b) => a.n - b.n);
    grid.replaceChildren(...list.map((l) => {
      const rec = progress.levels[l.id]; const locked = !isUnlocked(progress, l, levels);
      const b = document.createElement('button');
      b.className = 'cell' + (rec ? (rec.stars === 3 ? ' perfect' : ' done') : '') + (l.id === progress.last ? ' last' : '') + (locked ? ' locked' : '') + (isAdmin() && l.hard ? ' hard' : '');
      b.textContent = String(l.n); b.disabled = locked;
      if (isAdmin() && l.hard) b.title = `${l.secs}s`;
      if (!locked) b.onclick = () => onPick(l);
      return b;
    }));
  };
  draw();
  // 관리자(?stage=all)에게만: 어려웠던 판 모아 보기(팩 무관, 오래 걸린 순)
  if (isAdmin()) {
    const box = root.querySelector<HTMLElement>('.hardbox')!, list = root.querySelector('.hardlist')!;
    const hard = levels.filter((l) => l.hard).sort((a, b) => (b.secs ?? 0) - (a.secs ?? 0));
    if (hard.length) {
      box.hidden = false;
      list.replaceChildren(...hard.map((l) => {
        const b = document.createElement('button');
        b.className = 'cell hardcell' + (progress.levels[l.id] ? ' done' : '');
        b.innerHTML = `<span class="id">${l.pack} ${l.n}</span><span class="secs">${Math.round(l.secs ?? 0)}s</span>`;
        b.onclick = () => onPick(l);
        return b;
      }));
    }
  }
  host.replaceChildren(root);
  const unwatch = watchViewport(() => fitRoot(root));
  return { destroy() { unwatch(); root.remove(); } };
}
